import classNames from "classnames";
import SVG from "components/common/SVG";
import Modal from "react-modal";

import styles from "./style.module.scss";

const CustomModal = ({
  children,
  contentLabel,
  showModal,
  setShowModal,
  modalClassName,
  modalBodyClassName,
  showHeader = true,
  showFooter = true,
  primaryCtaHandler = () => {},
  primaryCtaText,
  secondaryCtaHandler = () => {},
  secondaryCtaText,
  primaryCtaEnabled = true,
  secondaryCtaEnabled = true,
}) => {
  return (
    <>
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        shouldCloseOnOverlayClick={true}
        portalClassName="react-modal"
        overlayClassName={styles.overlayModal}
        className={classNames(styles.modal, modalClassName)}
      >
        <div className={styles.modalContainer}>
          {showHeader && (
            <div className={styles.modalHeader}>
              <div className={styles.modalTitle}>{contentLabel}</div>
              <SVG onClick={() => setShowModal(false)} iconName={"images/close.svg"} className={styles.closeCta} />
            </div>
          )}

          <div className={classNames(styles.modalBody, modalBodyClassName)}>{children}</div>

          {showFooter && (
            <div className={styles.modalFooter}>
              <button disabled={!secondaryCtaEnabled} className={styles.secondaryCta} onClick={secondaryCtaHandler}>
                {secondaryCtaText}
              </button>
              <button disabled={!primaryCtaEnabled} className={styles.primaryCta} onClick={primaryCtaHandler}>
                {primaryCtaText}
              </button>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default CustomModal;
